import { Component } from '@angular/core';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';

@Component({
    selector: 'app-email-queue',
    templateUrl: './email-queue.component.html',
    styleUrls: ['./email-queue.component.scss'],
    standalone: false
})
export class EmailQueueComponent {
  pageName = CheckPageAccess.EMAILQUEUE

}
